import React from 'react'
import * as styles from '../assets/styles.module.scss'

const WHATSAPP_URL = 'https://wa.me/526677559873'

const SiteUtilities: React.FC = () => (
    <aside className={styles.SiteUtilities} aria-label="Contacto rápido">
        <a
            className={styles.WhatsAppButton}
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Escríbenos por WhatsApp"
            title="Escríbenos por WhatsApp"
        >
            <svg viewBox="0 0 32 32" aria-hidden="true" focusable="false">
                <path d="M16 3a12.8 12.8 0 0 0-11 19.4L3.4 29l6.8-1.6A12.9 12.9 0 1 0 16 3Zm0 23.3c-2 0-3.9-.5-5.5-1.5l-.4-.2-4 .9 1-3.9-.3-.4A10.3 10.3 0 1 1 16 26.3Zm5.7-7.7c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2l-1 1.2c-.2.2-.4.2-.7.1a8.5 8.5 0 0 1-4.2-3.7c-.3-.5.3-.5.9-1.7.1-.2.1-.4 0-.6l-1-2.4c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.4-1.2 1.2-1.2 2.9s1.2 3.3 1.4 3.6c.2.2 2.4 3.7 5.9 5.2 2.2.9 3 .9 4.1.7.7-.1 1.9-.8 2.2-1.5.3-.8.3-1.4.2-1.5-.2-.2-.4-.3-.7-.4Z" />
            </svg>
            <span>WhatsApp</span>
        </a>
    </aside>
)

export default SiteUtilities
